import alloyAnalytics from '@telus/alloy-analytics'
import { checkIsCartValid } from '../cartValidations'

const STORAGE_KEY = 'analyticsEvent'

const TOOL_NAME = 'digital_commerce_checkout'
const TOOL_TYPE = 'checkout'

const TOOL_NAME_PROMO_CODE = 'promo_code_panel'
const TOOL_TYPE_PROMO_CODE = 'promo_code'

const events = {
  pageLoaded: ({ cart, locale, isAuthenticated, linkType }) => {
    const { lang, prov } = locale
    const validationStatus = checkIsCartValid({ cart, prov, linkType })
    const mobilityPromoCode = alloyAnalytics.applyFormatter('mobilityPromoCode', cart)
    const toolSelections = mobilityPromoCode && `promo_code_applied-${mobilityPromoCode}`

    alloyAnalytics
      .event('pageLoaded')
      .webPageDetails({
        checkoutType: 'regular',
        orderType: alloyAnalytics.applyFormatter('orderType', cart),
        pageLanguage: lang,
        pageName: 'telus>personal>commerce>cart',
        pageType: 'cart',
        province: prov,
        userLoginStatus: isAuthenticated ? 'logged_in' : 'not_logged_in',
        addCoreProducts: true
      })
      .webInteraction('toolStart', {
        toolName: TOOL_NAME,
        toolType: TOOL_TYPE,
        toolSelections
      })
      .commerce('productCartViews', {
        cartID: cart?.root?.id,
        ...alloyAnalytics.applyFormatter('productsByType', cart)
      })
      .productListItems(alloyAnalytics.applyFormatter('cartProducts', cart))

    if (!validationStatus.isValid) {
      alloyAnalytics.webInteraction('errorEvent', {
        errorType: 'invalid',
        errorDetails: 'unified_commerce:invalid_cart',
        errorMessage:
          alloyAnalytics.applyFormatter('validationErrors', cart) ||
          validationStatus.reasons.join('|')
      })
    }

    alloyAnalytics.fire()
  },
  showDetails: (product) => {
    alloyAnalytics
      .event('toolSubmit')
      .webInteraction({
        toolName: TOOL_NAME,
        toolType: TOOL_TYPE,
        toolSelections: `show_details-${alloyAnalytics.applyFormatter('productName', product)}`
      })
      .fire()
  },
  removeFromCart: ({ product, cart }) => {
    alloyAnalytics
      .event('removeFromCart')
      .productListItems(alloyAnalytics.applyFormatter('product', product, cart))
      .fire()
  },
  openPromoCode: () => {
    alloyAnalytics
      .event('toolStart')
      .webInteraction({
        toolName: `${TOOL_NAME}-${TOOL_NAME_PROMO_CODE}`,
        toolType: `${TOOL_TYPE}-${TOOL_TYPE_PROMO_CODE}`
      })
      .fire()
  },
  redeemPromoCode: ({ code }) => {
    alloyAnalytics
      .event('toolComplete')
      .webInteraction({
        toolName: `${TOOL_NAME}-${TOOL_NAME_PROMO_CODE}`,
        toolType: `${TOOL_TYPE}-${TOOL_TYPE_PROMO_CODE}`,
        toolSelections: `promo_code_applied-${code}`
      })
      .fire()
  },
  removePromoCode: ({ code }) => {
    alloyAnalytics
      .event('toolSubmit')
      .webInteraction({
        toolName: `${TOOL_NAME}-${TOOL_NAME_PROMO_CODE}`,
        toolType: `${TOOL_TYPE}-${TOOL_TYPE_PROMO_CODE}`,
        toolSelections: `promo_code_removed-${code}`
      })
      .fire()
  },
  errorPromoCode: ({ code, type, message, status }) => {
    alloyAnalytics
      .event('toolError')
      .webInteraction({
        toolName: `${TOOL_NAME}-${TOOL_NAME_PROMO_CODE}`,
        toolType: `${TOOL_TYPE}-${TOOL_TYPE_PROMO_CODE}`,
        errorCode: status,
        errorType: type,
        errorMessage: message,
        errorDetails: code
      })
      .fire()
  },
  toolError: ({ data, status }) => {
    alloyAnalytics
      .event('toolError')
      .webInteraction({
        toolName: TOOL_NAME,
        toolType: TOOL_TYPE,
        errorType: data?.error,
        errorDetails: 'http_error',
        errorMessage: data?.message,
        errorCode: status
      })
      .fire()
  },
  storageEvents: {
    emptyCart: ({ cart, isAuthenticated }) => {
      const event = {
        webPageDetails: {
          checkoutType: 'regular',
          orderType: alloyAnalytics.applyFormatter('orderType', cart),
          pageName: 'telus>personal>commerce>cart>empty_cart',
          userLoginStatus: isAuthenticated ? 'logged_in' : 'not_logged_in'
        },
        webInteraction: [
          ['toolError', { toolName: TOOL_NAME, toolType: TOOL_TYPE, errorMessage: 'empty_cart' }]
        ],
        commerce: [['productCartViews', { cartID: cart?.root?.id }]]
      }

      // Data is sent via local storage and error events handled by dc-ui-shell
      localStorage.setItem(STORAGE_KEY, JSON.stringify(event))
    },
    error: ({ error }) => {
      const event = {
        webPageDetails: {
          pageName: 'telus>personal>commerce>cart>error'
        },
        webInteraction: [
          [
            'errorEvent',
            {
              errorCode: error?.status,
              errorType: error?.data?.error,
              errorMessage: error?.data?.message,
              errorDetails: 'http_error'
            }
          ]
        ]
      }

      // Data is sent via local storage and error events handled by dc-ui-shell
      localStorage.setItem(STORAGE_KEY, JSON.stringify(event))
    }
  }
}

export default events
